module.exports = __webpack_public_path__ + "assets/no-gender-icon.22655418.svg";